import { parseMessageData } from '../lib/message';
var MessageSources = ['YandexTrustPaymentForm', 'YandexTrustBindingForm'];
export var getPaymentMessage = function (messageData) {
    var data = parseMessageData(messageData);
    return MessageSources.includes(data === null || data === void 0 ? void 0 : data.source)
        ? data
        : { type: '', source: '', data: {} };
};
